import React from 'react';
import { Routes, Route } from "react-router-dom";
import Box from '@mui/material/Box';
import Header from './components/Header';
import HomePageMainSearch from './components/HomePageMainSearch';
import About from './components/About';
import AboutStatic from './components/AboutStatic';
import AboutScansStatic from './components/AboutScansStatic';
import FeatureSection from './components/FeatureSection';
import Testimonials from './components/Testimonials';
import ImgMediaCard from './components/ImgMediaCard';
import FooterStatic from './components/FooterStatic';
import PrivacyConfidentialityStatic from './components/PrivacyConfidentialityStatic';
import FaqsStatic from './components/FaqsStatic';
import CookiePolicyStatic from './components/CookiePolicyStatic';
import TermsAndConditionsStatic from './components/TermsAndConditionsStatic';
import ComplaintAndFeedbackStatic from './components/ComplaintAndFeedbackStatic';
import RefundTermsAndInsuranceStatic from './components/RefundTermsAndInsuranceStatic';
import BlogPost from "./components/BlogPost";
import { buildRoute } from './utils';

const MainLayout = ({ children }) => (
    <Box>
        <Header />
        <Box sx={{mt: '1rem'}} />
        {children}
        <FooterStatic />
    </Box>
);

const App = () => {
    return (
        <Routes>
            {['/', '/clp'].map((path, index) => (
                <Route 
                    key={index}
                    path={path} 
                    element={
                        <Box sx={{
                            backgroundColor: '#fafafa',
                        }}>
                            <Header />
                            <HomePageMainSearch />
                            <FeatureSection />
                            <About />
                            <Testimonials />
                            <ImgMediaCard />
                            <FooterStatic />
                        </Box>						
                    } 
                />
            ))}
            
            <Route 
                path={`${buildRoute('/content/aboutus')}`} 
                element={
                    <MainLayout>
                        <AboutStatic />
                    </MainLayout>
                } 
            />

            <Route 
                path={`${buildRoute('/content/privacyConfidentiality')}`} 
                element={
                    <MainLayout>
                        <PrivacyConfidentialityStatic />
                    </MainLayout>
                } 
            />

            <Route 
                path={`${buildRoute('/content/faqs')}`} 
                element={
                    <MainLayout>
                        <FaqsStatic />
                    </MainLayout>
                } 
            />

            <Route 
                path={`${buildRoute('/content/cookiepolicy')}`} 
                element={
                    <MainLayout>
                        <CookiePolicyStatic />
                    </MainLayout>
                } 
            />

            <Route 
                path={`${buildRoute('/content/termsandconditions')}`} 
                element={
                    <MainLayout>
                        <TermsAndConditionsStatic />
                    </MainLayout>
                } 
            />

            <Route 
                path={`${buildRoute('/content/complaintfeedback')}`} 
                element={
                    <MainLayout>
                        <ComplaintAndFeedbackStatic />
                    </MainLayout>
                } 
            />

            <Route 
                path={`${buildRoute('/content/refundtermsinsurance')}`} 
                element={
                    <MainLayout>
                        <RefundTermsAndInsuranceStatic />
                    </MainLayout>
                } 
            />

            <Route 
                path={`${buildRoute('/content/aboutscans')}`} 
                element={
                    <MainLayout>
                        <AboutScansStatic />
                    </MainLayout>
                } 
            />

            <Route 
                path={`${buildRoute('/blog/:slug')}`} 
                element={
                    <MainLayout>
                        <BlogPost />
                    </MainLayout>
                } 
            />
        </Routes>
    );
};

export default App;
